// extracted by mini-css-extract-plugin
export var changeIcon = "_5w-4";
export var container = "_5w-0";
export var divider = "_5w-7";
export var externalLinkIcon = "_5w-1";
export var green = "_5w-5";
export var helpCircleIcon = "_5w-3";
export var iconButton = "_5w-2";
export var red = "_5w-6";